(function () {
  if (customElements.get('cart-variant-select')) return;

  class CartVariantSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.select.addEventListener('change', () => this.swapVariant());
    }

    async swapVariant() {
      const newVariantId = parseInt(this.select.value, 10);
      const lineKey = this.dataset.lineKey;
      const quantity = parseInt(this.dataset.quantity || '1', 10);
      if (!newVariantId || !lineKey) return;

      this.classList.add('is-loading');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        // Remove the old line first so inventory-limited items don't collide,
        // then add the newly selected variant with the same quantity.
        const removeResponse = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
        if (!removeResponse.ok) throw new Error('remove failed');

        const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        const body = { items: [{ id: newVariantId, quantity: quantity }] };
        if (cartItems && cartItems.getSectionsToRender) {
          body.sections = cartItems.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await addResponse.json();

        if (cartItems && data.sections && cartItems.getSectionsToRender) {
          cartItems.getSectionsToRender().forEach((section) => {
            const element = document.getElementById(section.id);
            if (!element || !data.sections[section.id]) return;
            const target = section.selector ? element.querySelector(section.selector) || element : element;
            const html = new DOMParser().parseFromString(data.sections[section.id], 'text/html');
            const source = section.selector ? html.querySelector(section.selector) : html.body.firstElementChild;
            if (source) target.innerHTML = source.innerHTML;
          });
        } else {
          window.location.reload();
        }
      } catch (error) {
        window.location.reload();
      }
    }
  }

  customElements.define('cart-variant-select', CartVariantSelect);
})();
